import {t} from "@lingui/core/macro";
import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {Body} from "@khanacademy/wonder-blocks-typography";
import {mediaQueries} from "@repo/shared-styles";
import {staticUrl} from "@repo/urls";

type Props = Record<any, any>;

export default class Logo extends React.Component<Props> {
    render(): React.ReactNode {
        return (
            <View style={styles.container}>
                <img
                    alt={t`khan kids logo`}
                    className={css(styles.logo)}
                    src={staticUrl("/images/kids/khan_kids_logo.svg")}
                />
                <Body style={styles.body}>
                    {t`Inspire a lifetime of learning and discovery with our free, fun educational program for children ages two to eight.`}
                </Body>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        paddingTop: 100,
        paddingBottom: 60,
        maxWidth: 840,
        width: "100%",

        [mediaQueries.mdOrSmaller]: {
            maxWidth: 674,
            paddingTop: 80,
            paddingBottom: 40,
        },

        [mediaQueries.xsOrSmaller]: {
            maxWidth: 300,
            paddingBottom: 30,
        },
    },

    logo: {
        maxWidth: "100%",
    },

    body: {
        fontSize: 24,
        lineHeight: 1.42,
        maxWidth: 590,
        marginLeft: "14.5%",
        textAlign: "left",

        [mediaQueries.mdOrSmaller]: {
            fontSize: 22,
            lineHeight: 1.36,
            maxWidth: 530,
        },

        [mediaQueries.xsOrSmaller]: {
            fontSize: 11,
            marginTop: 8,
            marginLeft: 20,
            marginRight: 20,
            textAlign: "center",
        },
    },
});
